"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _axios = _interopRequireDefault(require("axios"));
var _elementUi = require("element-ui");
var _store = _interopRequireDefault(require("@/store"));
var _auth = require("@/utils/auth");
var _settingMer = _interopRequireDefault(require("@/utils/settingMer"));
var _wechat = require("@/libs/wechat");
var _apiSecurityHeaders = require("@/utils/apiSecurityHeaders");
var _storageKeys = require("@/constants/storageKeys");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// +----------------------------------------------------------------------
// | A2 [ A2赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.A2.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed A2并不是自由软件，未经许可不能去掉A2相关版权
// +----------------------------------------------------------------------
// | Author: A2 Team <admin@A2.com>
// +----------------------------------------------------------------------

function isLoginRoute() {
  var path = "".concat(window.location.pathname).concat(window.location.hash);
  return path.includes('/login');
}
var service = _axios.default.create({
  baseURL: _settingMer.default.apiBaseURL,
  timeout: 60000,
  // 过期时间
  withCredentials: true
});

// request interceptor
service.interceptors.request.use(function (config) {
  (0, _apiSecurityHeaders.applyApiSecurityHeaders)(config);
  var token = !_store.default.getters.token ? sessionStorage.getItem(_storageKeys.StorageKeys.ACCESS_TOKEN) : _store.default.getters.token;
  if (token) {
    config.headers['Authorization'] = token;
  }
  return config;
}, function (error) {
  return Promise.reject(error);
});

// response interceptor
service.interceptors.response.use(function (response) {
  var res = response.data;
  var code = Number(res.code);
  // if the custom code is not 20000, it is judged as an error.
  if (code === 401) {
    var requestUrl = response.config && response.config.url || '';
    var isAuthRequest = /\/login$|currentUserInfo|getCurrentUser|getAdminInfoByToken/.test(requestUrl);
    if (!isLoginRoute() && !isAuthRequest) {
      _elementUi.Message.error('登录环境检测异常，请刷新页面重试');
      _store.default.dispatch('user/resetToken');
      window.location.href = '/login';
    }
    return Promise.reject(res.message || '未授权');
  } else if (code === 403) {
    _elementUi.Message.error('没有权限访问。');
  }
  if (code !== 200) {
    if ((0, _wechat.isPhone)()) {
      //移动端
      return Promise.reject(res || 'Error');
    }
    // 登录页自行处理提示，避免与页面内 toast 重复
    if (!isLoginRoute()) {
      (0, _elementUi.Message)({
        message: res.message || 'Error',
        type: 'error',
        duration: 5 * 1000
      });
      return Promise.reject(res.message);
    }
    return Promise.reject({
      code: code,
      message: res.message || 'Error'
    });
  } else {
    return res.data;
  }
}, function (error) {
  // 登录页由页面统一提示，避免 Network Error + 业务文案双弹
  if (!isLoginRoute()) {
    (0, _elementUi.Message)({
      message: error.message || '网络异常，请稍后重试',
      type: 'error',
      duration: 5 * 1000
    });
  }
  return Promise.reject(error);
});
var _default = exports.default = service;